export default __webpack_public_path__ + "static/media/Billing Status_Dark2.3ed2b523.svg";